var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-spin',{attrs:{"spinning":_vm.loadingInsights}},[_c('a-row',[_c('apexchart',{attrs:{"height":"400px","type":"bar","options":_vm.opensChartsOptions,"series":_vm.opensChartsSeries}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }